// @ts-ignore
import { getApiForUrl } from "bonavendi-js";

export interface IApiHosts {
  [index: string]: string;
}

const ApiHosts: IApiHosts = {
  "de-DE": `https://${process.env.NEXT_PUBLIC_BV_API_URL_DE}`,
  "de-AT": `https://${process.env.NEXT_PUBLIC_BV_API_URL_AT}`,
  "en-US": `https://${process.env.NEXT_PUBLIC_BV_API_URL_US}`,
};

export const bvdApiClient = (locale?: string) =>
  getApiForUrl(ApiHosts[locale || "de-DE"]);
